export default "__VITE_PUBLIC_ASSET__afb656bd__"